import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueuesAgentAndIssueViewEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const queuesAgentAndIssueViewEntryPoint: EntryPoint<
	QueuesAgentAndIssueViewEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<QueuesAgentAndIssueViewEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-queues-agent-and-issue-view", jiraSpaEntry: "async-servicedesk-queues-agent-and-issue-view" */ './SpaApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
